module.exports = __webpack_public_path__ + "static/img/01.b6de589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_weinfelden/01.jpg
// module id = 449
// module chunks = 1